<template>
    <div class="pt-4 pb-5 px-5">
        <div >
            <!-- class="individual-info border-none" -->
            <h3 class="sub-title">{{$t('passInfo.cntDet')}}</h3>
            <!--     <label>{{$t('passInfo.cntDet')}}</label>-->
            <div class='row' >
<!-- class="custom-row-pass pt-20px" -->
                <div class='col'  sm="12" md="4" v-if="rule.emailCtrl!=null && rule.emailCtrl.isVisible" >

<!-- class="custom-input-pass" -->
                    <ValidationProvider
                            :rules="rule.emailRules"
                            :name="$t('passInfo.email')"
                            v-slot="{ errors }"
                    >
                        <label>{{$t('passInfo.email')}}</label>
                        <input
                                id="email"
                                class="form-control"
                                v-model="contDetail.email"
                                :placeholder="$t('passInfo.mailPl')"
                                :disabled="rule.emailCtrl && rule.emailCtrl.isDisable"
                        />
                        <div  v-if="errors && errors[0]" class="invalid-feedback icon">
                            <span>{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class='col' sm="12" md="8">
                    <div class='row'>
                    <div class='col' sm="12" md="6">
                         <!-- class="custom-input-pass-multi country-code-wrapper" -->
                        <label>{{$t('passInfo.mblNo')}}</label>
                        <cDropDown
                                :isAllowEmpty="false"
                                :ctrlName1="'calling_code'"
                                :ctrlCode="'countrycode'"
                                :isShowCode="false"
                                :isMultiple="false"
                                :isSearchable="true"
                                :url="getCountryServiceURL()"
                                rules="required"
                                :ctrlName="'value'"
                                :disabled="rule.mobileNoCtrl.isDisable"
                                :selValue="contDetail.mobileCodeObj"
                        />

                    </div><div class='col'  sm="12" md="6" v-if="rule.mobileNoCtrl && rule.mobileNoCtrl.isVisible" >
                    <!-- class="custom-input-pass mobile-number" -->
                        <label></label>
                        <ValidationProvider
                                :rules="rule.mobileNoRules"
                                :name="$t('passInfo.mblNo')"
                                v-slot="{ errors }"
                        >
                            <input
                                    id="mno"
                                    :name="$t('passInfo.mblNo')"
                                    class="form-control"
                                    v-model="contDetail.mobileNo"
                                    :placeholder="$t('passInfo.mblPl')"
                                    :disabled="rule.mobileNoCtrl && rule.mobileNoCtrl.isDisable"
                            />
                            <div  v-if=" errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>



                    </div>
                    </div>
                    <div class="mobile-info">{{$t('passInfo.mobileInfo')}}</div>
                </div>


            </div>
            <div class='row' >
                <!-- class="custom-row-pass mob-mt-30px" -->
                <div class='col' v-if="rule.cNameCtrl && rule.cNameCtrl.isVisible" >
                    <!-- class="custom-input-pass" -->
                    <ValidationProvider
                            :rules="rule.cNameRules"
                            :name="$t('passInfo.cName')"
                            v-slot="{ errors }"
                    >
                        <label>{{$t('passInfo.cName')}}</label>
                        <input
                                id="cName"
                                class="form-control"
                                v-model="contDetail.cName"
                                type="text"
                                :placeholder="$t('passInfo.contPl')"
                                :disabled="rule.cNameCtrl && rule.cNameCtrl.isDisable"
                                @change="getContactName"
                        />
                        <div  v-if="errors && errors[0]" class="invalid-feedback icon">
                            <span>{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class='row' >
                <!-- class="custom-row-pass" -->
              <div class="m-pass-message">
                <ul>
                <li>{{$t('passInfo.mailInfo1')}}</li>
                <li>{{$t('passInfo.mailInfo2')}}</li>
              </ul>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Logger from "../../../../services/logger";
    import BaseConfiguration from "../../../../config/base";

    import {ValidationObserver} from "vee-validate";
    import {ValidationProvider, localize} from "vee-validate";
    import SERVICE_URL from "../../../../config/API_DATA";
    import cDropDown from "../../../../components/form/cDropDown";
    import {mapGetters, mapActions} from "vuex";
    import {COMPONENT_NAME} from "../../../../util/constants";

    export default {
        name: COMPONENT_NAME.C_CONTACT,
        components: {
            cDropDown,

            ValidationObserver,
            ValidationProvider
        },
        props: {
            contDetail: {
                type: Object,
                default: null
            },
            mblCode: {
                type: Array,
                default: null
            },
            rule: {
                type: Object,
                default: null
            }
        },
        methods: {
            getCountryServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
                return SERVICE_URL.GET_COUNTRY_LIST;
            },

            getContactName(){
                if(this.contDetail.cName)
                this.contDetail.cName = this.contDetail.cName.toUpperCase();
            }
        }
        // created(){
        //   this.contDetail.mobileCode=this.mblCode[0].nationality.calling_code;
        // }
    };
</script>

<style scoped>
    .cname {
        text-transform: uppercase;
    }
</style>
